import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// @ts-ignore
import s from './form.css';
import MysketchPicker from '../../../components/MysketchPicker/MysketchPicker';
import Table from '../Table/Table';
import Collapse, { Panel } from '../../../components/Collapse/Collapse';


const createListItem = (list) => {
  let dataListItem = {}
  list.forEach(element => {
    dataListItem[element.value] = ''
  });
  return dataListItem
}

class IndustryContent extends Component {
  constructor (props) {
    super(props);

    this.dataRef = null
    this.labelDataRef = null

    this.state = {
      colorEditIndex: null,
      itemId: null,
      itemColor: '',
      itemName: '',
      name: '',
      dataListItem: createListItem(props.color),
      errorStatus: {
        state: false,
        msg: ''
      }
    }
  }
  

  componentWillReceiveProps(nextProps) {
    if (nextProps.list !== this.props.list) {
      const dataDom = this.dataRef
      dataDom.value = this.getTextArea(nextProps.list)
    }
    if (nextProps.labelList !== this.props.labelList) {
      const labelDataDom = this.labelDataRef
      labelDataDom.value = this.getLabelText(nextProps.labelList)
    }
  }

  
  setError = (state, msg) => {
    this.setState({
      errorStatus: {
        state, msg
      }
    })
  }
  handleChange = (type, e) => {
    const val = typeof e === 'string' ? e : e.target.value 
    this.setState({
      [type]: val
    })
  }

  /**
   * 添加/修改颜色
   *
   * @memberof IndustryContent
   */
  addColorItem = () => {
    let { onChange, color } = this.props;
    const { itemColor, itemName, colorEditIndex, itemId } = this.state
    color[colorEditIndex] = {
      name: itemName,
      color: itemColor,
      value: itemId
    }

    this.setState({
      colorEditIndex: null,
      itemColor: '',
      itemName: '',
      itemId: ''
    })

    onChange({}, {colorList: color});
  }

  renderColorCake = (color) => {
    const style = {
      display: 'inline-block',
      height: 20,
      width: 20,
      background: color,
      verticalAlign: 'middle'
    }
    return <span style={style}></span>
  }

  colorEdit = (index) => {
    const {color} = this.props;
    const item = color[index]
    this.setState({
      colorEditIndex: index,
      itemName: item.name,
      itemColor: item.color,
      itemId: item.value
    })
  }


  clear = () => {
    const { onChange } = this.props;
    onChange({}, []);
  }

  onChangeColors = (index, key, value) => {
    let { onChange, color } = this.props;
    const item = color[index]

    color[index] = {
      ...item,
      [key]: value
    }

    onChange([], {
      colorList: color
    })
  }

  textareaChange = (e) => {
    const {onChange} = this.props
    const {value} = e.target
    this.setError(false, '')
    const list = value.split('\n').map(item => {
      const itemArr = item.trim().split(/\s+/)
      const [name, agreeable, neutrality] = itemArr
      if (isNaN(parseInt(agreeable)) || isNaN(parseInt(neutrality))) { this.setError(true, '数据格式错误')}
      return {
        name,
        agreeable,
        neutrality
      }
    })

    onChange({}, list);
  }

  /**
   * 将数组转文本
   * @memberof IndustryContent
   */
  getTextArea = (list) => {
    const result = list.map(item => {
      let result = item.name || ''
      if (item.agreeable !== undefined) {
        result += `\t${item.agreeable}`
      }
      if (item.neutrality !== undefined) {
        result += `\t${item.neutrality}`
      }
      return result
    }).join('\n')
    

    return result
  }

  labelTextChange = (e) => {
    const {onChange} = this.props
    const {value} = e.target

    const list = value.split('\n').map(item => {
      const texts = item.split(/\s/)
      return {
        xAxis: texts[0],
        label: texts[1] || '',
        yAxis: texts[2] || '',
      }
    })

    onChange({}, {labelList: list})
  }

  /**
   * 标注文本转字符串
   * @memberof IndustryContent
   */
  getLabelText = (list) => {
    const text = list.map(item => {
      return Object.values(item).filter(item => item !== '').join('\t')
    }).join('\n')

    return text
  }



  render () {
    const {list, color} = this.props;
    const {colorEditIndex, itemColor, itemName, errorStatus} = this.state;

    return (
      <Collapse className={s.collapse}>
        <Panel header="图表颜色">
          <Table 
            header={() =>
              <tr>
                <th>图例标签</th>
                <th>值</th>
                <th style={{width:150}}>操作</th>
              </tr>
            }
            body={() => color.map((item, index) => 
              <tr key={index}>
                <td>{item.name}</td>
                <td>{this.renderColorCake(item.color)}</td>
                <td>
                  <button onClick={() => this.colorEdit(index)}>修改</button>
                </td>
              </tr>  
            )}
          />

          {typeof colorEditIndex === 'number' && 
            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: 10}} >
              {itemName}
              <MysketchPicker value={itemColor} onChange={e=>{this.handleChange('itemColor', e)}} />
              <button onClick={this.addColorItem}>修改</button>
            </div>
          }
        </Panel>

        <Panel header="数据" expand>
          <textarea ref={(ref) => this.dataRef = ref} onBlur={this.textareaChange} cols={70} rows={8} />
          {errorStatus.state && <p style={{color: '#f00'}}>{errorStatus.msg}</p>}

          <Table 
            header={() =>
              <tr>
                <th>横坐标</th>
                <th>条形图</th>
                <th>折线图</th>
              </tr>
            }
            body={() => list.map((item, index) => 
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.agreeable}</td>
                <td>{item.neutrality}</td>
              </tr>  
            )}
          />
        </Panel>
        <Panel header="标注" expand>
          <p style={{color: '#f00'}}>* /s代表一个空格，/n代表换行, 结尾0代表柱状图标注，1代表折线图标注</p>
          <textarea ref={(ref) => this.labelDataRef = ref} onBlur={this.labelTextChange} cols={70} rows={8} />
        </Panel>

      </Collapse>
    )
  }
};



export default withStyles(s)(IndustryContent)


// WEBPACK FOOTER //
// src/routes/customChart/components/Multiaxis.js